module.exports = __webpack_public_path__ + "static/media/hoodie.7cdf3e3e.svg";